import React, { Component } from 'react';
import { connect } from 'react-redux'

import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import Wallet from '../Containers/Wallet';
import Validator from "../Containers/Validator";
import TopContent from "../Components/TopContent";

class PaymentPage extends Component {
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <Validator/>
            <Centered>
              <div className="spacer-40px" />
              <TitleText>Fund gift</TitleText>
              <Wallet />
              <div className="spacer-40px" />
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
  senderEmail: state.gift.senderEmail,
  giftAmount: state.gift.giftAmount,
  template: state.gift.template,
  note: state.gift.note,
  wallet: state.wallet.wallet
});

export default connect(mapStateToProps)(PaymentPage);



// WEBPACK FOOTER //
// ./src/Pages/PaymentPage.js